import yaml from "js-yaml"

//yamlファイル読み込み
async function loadYaml(url) {
    let text = await (await fetch(url)).text();
    let ob = yaml.load(text);
    return ob;
}

//属性に応じたyamlデータの絞り込み
function filterAttribute(targets, yamlData, course) {
    let result = [];
    if (targets == 'all') {//研究室を全て表示する場合
        result = yamlData
    }
    else {//一部表示の場合
        targets.forEach(target => {
            let categories = yamlData.filter(category => category[course] == target)
            result.push(categories[0])
        })
    }
    return result;
}
//バリデーション
function validationYaml(repository){
    //常時表示
    //マッチング率の表示について
    console.log('マッチング率は' + repository.setting.score_visible_min_rank + '位までの' + repository.setting.score_visible_min_similarity + '%以上のスコアが表示されます。');

    //キーワード算出モードについて
    let keyword_score_mode = 'cos類似度を用いて';
    let vector_length = 'ユーザーが選択した数(可変)';
    let keyword_weight_regulation_value = '定数100';
    if(repository.setting.keyword_score_mode != 'COS_VECTOR_LENGTH_FIX' && repository.setting.keyword_score_mode != 'COS_VECTOR_LENGTH_VARIABLE') {
        keyword_score_mode = '内積を活性化関数を用いて規格化して';        
    }
    else if(repository.setting.keyword_score_mode == 'COS_VECTOR_LENGTH_FIX') {
        vector_length = 'キーワードマスタ長で固定';
    }
    if(repository.setting.keyword_weight_regulation_value == 'MAX_WEIGHT_ALL') {
        keyword_weight_regulation_value = '全てのキーワード内の最大値';
    }else if(repository.setting.keyword_weight_regulation_value == 'MAX_WEIGHT_ONE_KEYWORD') {
        keyword_weight_regulation_value = '1つのキーワード内での最大値'
    }
    console.log('算出方法は' + keyword_score_mode + 'おり、ベクトル長は' + vector_length + 'であり、' + keyword_weight_regulation_value + 'で正規化しています。');

    //順位について
    console.log('順位は' + repository.setting.others_laboratories + '位までを表示しています。');

    //キーワードアイコンについて
    console.log('キーワードアイコンは' + repository.setting.keyword_icon + '個まで表示しています。');


    //異常時のみ表示
    //重みが5段階の数字になっているか（数字以外のものが入っていないか）
    repository.laboratory_subject.forEach(laboratory => {
        const regexp = new RegExp(/^[-]?([1-9]\d*|0)$/);
        let check_subject = Object.keys(laboratory.subject_weights).filter(subject => { return !regexp.test(laboratory.subject_weights[subject]) })
        if(check_subject.length > 0) {
            console.log(laboratory.laboratory_name + ' 研究室の重みに数字以外が入っています。 科目名: ' + check_subject);
        }
        let check_subject_weight = Object.keys(laboratory.subject_weights).filter(subject => { return (0 > laboratory.subject_weights[subject] || laboratory.subject_weights[subject] > 5) })
        if(check_subject_weight.length > 0) {
            console.log(laboratory.laboratory_name + ' 研究室の重みの範囲が0~5ではありません。 科目名: ' + check_subject_weight);
        }
    })

    //キーワードの重みに数字外のものが入っていないか
    repository.laboratory_keyword.forEach(laboratory => {
        const regexp = new RegExp(/^[-]?([1-9]\d*|0)$/);
        let check_keyword = Object.keys(laboratory.keyword_weights).filter(keyword => { return !regexp.test(laboratory.keyword_weights[keyword]) })
        if(check_keyword.length > 0) {
            console.log(laboratory.laboratory_name + ' 研究室の重みに数字以外が入っています。 キーワード名: ' + check_keyword);
        }
        //キーワードの重み合計が100になっているか
        if(check_keyword.length == 0) {
            let sum = 0;
            Object.values(laboratory.keyword_weights).forEach(keyword => {return sum += keyword})
            if(sum != 100) {
                console.log(laboratory.laboratory_name + ' 研究室のキーワードの重み合計が' + sum + 'になっています。');
            }
        }
    })

    //研究室の重み設定がされているか
    repository.laboratory.forEach(laboratory => {
        if(!repository.laboratory_subject.some(subject => subject.laboratory_name == laboratory.name)) {
            console.log(laboratory.name + ' 研究室の科目の重みがありません。')
        }
        if(!repository.laboratory_keyword.some(keyword => keyword.laboratory_name == laboratory.name)) {
            console.log(laboratory.name + ' 研究室のキーワードの重みがありません。')
        }
    })

    //キーワードの大項目が持つkeywordsのものが小項目の中に全てあるか
    repository.keyword.categories.forEach(category => {//カテゴリのキーワードが小項目にあるか判別させる
        category.keywords.some(keyword => {
            if(!repository.keyword.keywords.some(key => {
                return key == keyword;
            })){
                console.log(keyword + 'は小項目に存在しません。')
            }
        })
    })

    //研究室の重み設定に科目、キーワードマスタにないものが存在しないか
    repository.laboratory_subject.forEach(subjects => {
        Object.keys(subjects.subject_weights).forEach(laboratory_subject => {
            let subject_check = false;
            repository.subject.forEach(category => {
                if(category.subjects.some(master_subject => master_subject.name == laboratory_subject)) {
                    subject_check = true;
                }
            })
            if(!subject_check) {
                console.log(subjects.laboratory_name + ' 研究室の' + laboratory_subject + 'という科目は存在しません。')
            }
        })
    })

    repository.laboratory_keyword.forEach(keywords => {
        Object.keys(keywords.keyword_weights).forEach(laboratory_keyword => {
            let keyword_check = false;
            repository.keyword.keywords.forEach(keyword => {
                if(keyword == laboratory_keyword) {
                    keyword_check = true;
                }
            })
            if(!keyword_check) {
                console.log(keywords.laboratory_name + ' 研究室の' + laboratory_keyword + 'というキーワードは存在しません。')
            }
        })
    })
}

class Repository {
    constructor() {

    }

    static async build() {
        const currentDate = new Date();

        // 年、月、日、時、分、秒を取得
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth() + 1;
        const day = currentDate.getDate();
        const hours = currentDate.getHours();
        const minutes = currentDate.getMinutes();
        const seconds = currentDate.getSeconds();

        // 日付文字列の作成
        const formattedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day} ${hours}:${minutes}:${seconds}`;
        
        const repository = new Repository()
        repository.userAttribute = await loadYaml("./yaml/userAttribute.yml?" + formattedDate);
        repository.subject = await loadYaml("./yaml/subject.yml?" + formattedDate);
        repository.laboratory = await loadYaml("./yaml/laboratory.yml?" + formattedDate);
        repository.laboratory_subject = await loadYaml("./yaml/laboratory_subject_weight.yml?" + formattedDate);
        repository.laboratory_keyword = await loadYaml("./yaml/laboratory_keyword_weight.yml?" + formattedDate);
        repository.keyword = await loadYaml("./yaml/keyword.yml?" + formattedDate);
        repository.setting = await loadYaml("./yaml/setting.yml?" + formattedDate);
        validationYaml(repository);
        return repository
    }

    getSubjectCategories(userAttribute) {
        // 引数のuserAttributeに応じた科目を返す
        return filterAttribute(userAttribute.target_subjects, this.subject, 'category_name');
    }
    getLaboratories(userAttribute) {
        // 引数のuserAttributeに応じた研究室を返す
        const laboratories = filterAttribute(userAttribute.target_laboratories, this.laboratory, 'name');

        laboratories.forEach(laboratory => {
            const subject_weights = this.laboratory_subject.find((lab) => {
                return lab.laboratory_name == laboratory.name
            })
            const keyword_weights = this.laboratory_keyword.find((lab) => {
                return lab.laboratory_name == laboratory.name
            })

            laboratory.subject_weights = subject_weights ? subject_weights.subject_weights : null
            laboratory.keyword_weights = keyword_weights ? keyword_weights.keyword_weights : null
        })

        return laboratories
    }
    getKeywordCategories(userAttribute) {
        // 引数のuserAttributeに応じたキーワードを返す
        return filterAttribute(userAttribute.target_keywords, this.keyword.categories, 'name');
    }
}

export {
    loadYaml,
    filterAttribute,
    Repository,
    validationYaml
}